import React from "react";
import { Modal } from "react-bootstrap";
import HealthClassAnalysis from "./HealthClassAnalysis";

export default function HealthClassCalc(props) {
  return (
    <Modal show={props.fields.modalHealthCalcIsOpen} className="health-analysis-model" scrollable={true} onHide={() => { props.fields.setModalHealthCalcIsOpen(false) }} backdrop="true" size="lg">
      <Modal.Body>
        <HealthClassAnalysis fields={props.fields} isPrequote={props.isPrequote} currentHealthClass={props.currentHealthClass} onHealthClassChange={props.onHealthClassChange} />
      </Modal.Body>
    </Modal>
  );
}
